import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/golf-bags-storages-services-near-me.jpg'),
    alt: 'golf bags storages services near me page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'golf bags storages services near me page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Golf Bags <span>Storage</span><span>Services Near Me Fast</span>',
  description:
    'Looking for a secure, convenient place to store your golf bags and gear? Our Golf Bags Storage Services are designed to keep your equipment safe and ready for your next round. Enjoy local, reliable storage with easy access whenever you need it.',
  image: {
    url: '/images/v2/pages/landing-pages/golf-bags-storages-services-near-me/hero-image.jpg',
    alt: 'Golf Bags Storage Services Near Me Fast'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Find Golf Bags Storage Near You' }
}

export const ourProcessSectionContent = {
  title: 'How Golf Bags Storage Services Work',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/golf-bags-storages-services-near-me/how-golf-bags-storage-services-work.png',
    alt: 'How Golf Bags Storage Services Work'
  },

  articles: [
    {
      id: 1,
      title: 'Simple Pickup and Delivery',
      description:
        'Schedule a pickup at your convenience, and our team will collect your golf bags and gear from your location. Need them shipped somewhere? We can handle that too!',
      image: {
        src: '/images/v2/pages/landing-pages/golf-bags-storages-services-near-me/simple-pickup-and-delivery.png',
        alt: 'Simple Pickup and Delivery'
      }
    },
    {
      id: 2,
      title: 'Secure Storage Options',
      description:
        'Your golf bags are stored in climate-controlled facilities, ensuring they stay in perfect condition, ready for your next game.',
      image: {
        src: '/images/v2/pages/landing-pages/golf-bags-storages-services-near-me/secure-storage-options.png',
        alt: 'Secure Storage Options'
      }
    },
    {
      id: 3,
      title: 'Flexible Storage Plans',
      description:
        'Whether you need storage for a few weeks or several months, we offer flexible options to fit your schedule and budget.',
      image: {
        src: '/images/v2/pages/landing-pages/golf-bags-storages-services-near-me/flexible-storage-plans.png',
        alt: 'Flexible Storage Plans'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Secure Golf Bags Storage Solutions',
  description:
    'Our golf bags storage services are ideal for golfers who need a safe, convenient place to store their equipment. Whether you’re traveling, moving, or just need seasonal storage, we’ve got you covered.',
  image: {
    src: '/images/v2/pages/landing-pages/golf-bags-storages-services-near-me/secure-golf-bags-storage-solutions.jpg',
    alt: 'Secure Golf Bags Storage Solutions'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Golf Bags Storage Services',

  cards: [
    {
      id: 1,
      title: 'Convenient and Accessible',
      description:
        'Store your golf bags close by with easy access whenever you need them, so you can hit the course without any hassle.',
      image: {
        src: '/images/v2/pages/common/flexible-storage-duration.png',
        alt: 'Convenient and Accessible'
      }
    },
    {
      id: 2,
      title: 'Safe and Secure',
      description:
        'Your golf bags are stored in top-tier, monitored facilities, ensuring their safety and protection against the elements.',
      image: {
        src: '/images/v2/pages/common/enhanced-security2.png',
        alt: 'Safe and Secure'
      }
    },
    {
      id: 3,
      title: 'Affordable Options',
      description:
        'We offer cost-effective pricing with flexible storage durations, so you only pay for what you need.',
      image: {
        src: '/images/v2/pages/common/affordable-storage-plans.png',
        alt: 'Affordable Options'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Use Golf Bags Storage Services?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Frequent Travelers',
          description:
            "If you're constantly on the move and need a place to store your golf equipment, we offer secure and accessible storage options."
        },
        {
          id: 2,
          title: 'Seasonal Golfers',
          description:
            'Need a place to store your gear during the off-season? We provide convenient storage solutions to keep your golf bags safe year-round.'
        },
        {
          id: 3,
          title: 'Golf Course Members',
          description:
            'Store your equipment close to the course without the hassle of taking it back and forth every time you play.'
        },
        {
          id: 4,
          title: 'Golf Enthusiasts with Limited Space',
          description:
            'If you don’t have the space at home, our services offer an ideal solution for storing your golf bags and equipment.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/golf-bags-storages-services-near-me/who-should-use-golf-bags-storage-services.jpg',
        alt: 'Who Should Use Golf Bags Storage Services?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Golf Bags Storage Services',

  cards: [
    {
      id: 1,
      title: 'Short-Term Storage for Golf Bags',
      description:
        "Whether you're heading on a trip or need storage for a few weeks, our short-term storage options are perfect for keeping your gear secure while you're away.",
      image: {
        src: '/images/v2/pages/common/short-term-rental-solutions.png',
        alt: 'Short-Term Storage for Golf Bags'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Golf Bag Pickup and Delivery',
      description:
        'Need us to pick up and deliver your golf bags? We offer pickup and drop-off services that make storing and retrieving your gear easy.',
      image: {
        src: '/images/v2/pages/common/pickup-and-delivery-services.png',
        alt: 'Golf Bag Pickup and Delivery'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Long-Term Storage for Golf Equipment',
      description:
        'For those who need to store their gear over the off-season or for an extended period, we offer flexible long-term storage solutions.',
      image: {
        src: '/images/v2/pages/common/long-term-storage.png',
        alt: 'Long-Term Storage for Golf Equipment'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Climate-Controlled Golf Storage',
      description:
        'Protect your golf equipment from humidity and temperature fluctuations with our climate-controlled storage, ensuring your gear stays in top condition.',
      image: {
        src: '/images/v2/pages/common/climate-controlled-storage.png',
        alt: 'Climate-Controlled Golf Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose Us for Golf Bags Storage Services?',

  image: {
    url: '/images/v2/pages/landing-pages/golf-bags-storages-services-near-me/why-choose-us-for-golf-bags-storage-services.jpg',
    alt: 'Why Choose Us for Golf Bags Storage Services?'
  },

  articles: [
    {
      id: 1,
      title: 'Convenient Locations',
      description:
        'We have golf bag storage options near you, making it easy to store your equipment without traveling far.'
    },
    {
      id: 2,
      title: 'Flexible Storage Durations',
      description:
        'We offer storage solutions for both short-term and long-term needs, providing flexibility based on your schedule.'
    },
    {
      id: 3,
      title: 'Affordable and Transparent Pricing',
      description: 'Our pricing plans are clear, so you only pay for the storage you need without hidden fees.'
    },
    {
      id: 4,
      title: 'Protection from Damage',
      description:
        'Our storage facilities are designed to protect your golf bags from dust, moisture, and temperature fluctuations, preserving their quality.'
    },
    {
      id: 5,
      title: 'Secure and Climate-Controlled Facilities',
      description:
        'Your golf bags are stored in secure, climate-controlled units, ensuring they stay in excellent condition.'
    },
    {
      id: 6,
      title: 'Easy Pickup and Delivery',
      description:
        'We offer convenient pick-up and delivery options, so you can retrieve or store your golf bags with minimal effort.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Golf Bags Storage Services Near Me Fast And Secure',
  description:
    'Golf bags storage services near me available now. Fast, secure, and affordable solutions for storing your golf equipment safely.',
  image: {
    src: '/images/v2/pages/landing-pages/golf-bags-storages-services-near-me/golf-bags-storage-services-near-me-fast-and-secure.png',
    alt: 'Golf Bags Storage Services Near Me Fast And Secure'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Find Storage Near You' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Shipping Partners',
  description: 'We work with top carriers to ensure your golf bags are handled with care during shipping and storage.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        "FedEx offers reliable, fast shipping solutions for your golf bags, ensuring timely delivery whether you're traveling or storing your gear.",
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        "DHL helps deliver your golf equipment securely and efficiently, whether you're shipping it home, to the course, or to a new location.",
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        "UPS offers reliable shipping for your golf bags, ensuring they're safely delivered to your destination without delay.",
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com/' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
